import { Component, computed, inject, input, output } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { RouterLink } from '@angular/router';
import { ENVIRONMENT } from '../../../../environments/environment.interface';
import { SponsorPerson } from '../../../api/app-types/sponsor.app';
import { Paginator } from '../../../core/components/paginator/paginator';
import { PaginatedResponse } from '../../../shared/pagination/paginated-response';
import { SponsorPersonsItem } from '../sponsor-persons-item/sponsor-persons-item';

@Component({
	selector: 'lvr-sponsor-persons-list',
	imports: [Paginator, SponsorPersonsItem, RouterLink],
	templateUrl: './sponsor-persons-list.html',
	styleUrl: './sponsor-persons-list.scss',
})
export class SponsorPersonsList {
	private readonly environment = inject(ENVIRONMENT);
	public readonly personsPage = input<PaginatedResponse<SponsorPerson>>();
	public readonly persons = computed(() => (this.personsPage()?.entities ?? []).filter((p) => !p.isDeactivated));
	public readonly totalItems = computed(() => this.personsPage()?.totalEntities ?? 0);
	public readonly sponsorName = input<string>('');

	public readonly pageIndex = computed(() => this.personsPage()?.offset ?? 0);
	public readonly pageSize = computed(() => this.personsPage()?.range ?? this.environment.defaultPageSize);

	public readonly queryParams = computed(() => ({
		offset: this.pageIndex(),
		range: this.pageSize(),
	}));

	public readonly showFirstLastButtons = true;
	public readonly hidePageSize = false;

	public readonly pageRequested = output<{ pageIndex: number; pageSize: number }>();

	public handlePageEvent(event: PageEvent) {
		this.pageRequested.emit({ pageIndex: event.pageIndex, pageSize: event.pageSize });
	}
}
